import Game from "../../../../../src/Game";
import { rootEventBus, EnumRootEventBus } from "../../../../../src/managers/RootEventBus";
import InfoSlider from "../../../../../src/entities/InfoSlider/InfoSlider";
import Circle from "../../../../../src/entities/Circle";
import PointManager from "./PointManager/PointManager";
import PointTagManager from "./PointTagManager";
import LineManager from "./LineManager";
import AngleManager from "./AngleManager";
import SliderManager from "./SliderManager";
import CircleAnimationManager from "./CircleAnimationManager/CircleAnimationManager";
import GuideText from "../../../../../src/entities/GuideText";
import isPortail from "../../../../../src/utils/isPortial";
import { CIRCLE_RADIUS, CENTER_OF_CIRCLE, INITIAL_RADIANS, ARC_COLOR_ARR, INFO_SLIDER_COORD } from "../types/Config";


export default class ComponentManager {
	static instance: ComponentManager;
	Game = Game.getInstance();
	circleRadius = CIRCLE_RADIUS;
	cCoord = isPortail(this.Game.getDim(), CENTER_OF_CIRCLE);
	PointManager = new PointManager(this.cCoord);
	PointTagManager = new PointTagManager(this.cCoord);
	LineManager = new LineManager(this.cCoord);
	AngleManager = new AngleManager(this.cCoord);
	circle = new Circle(this.cCoord, [...INITIAL_RADIANS, ...INITIAL_RADIANS], ARC_COLOR_ARR);
	guideText = new GuideText(undefined, true);
	InfoSlider = new InfoSlider(INFO_SLIDER_COORD)
	SliderManager = new SliderManager();
	CircleAnimationManager: CircleAnimationManager;
	constructor() {
		this.CircleAnimationManager = new CircleAnimationManager(
			this.PointManager,
			this.AngleManager,
			this.LineManager,
			this.circle,
			this.cCoord
		)
		this.drawElements();
		rootEventBus.on(EnumRootEventBus.drawElements, () => this.drawElements());
	}
	drawElements() {
		const radians = this.PointManager.getRadians();
		const redPointsCoord = this.PointManager.getRedPointsCoord();
		const chordPoints = this.PointManager.getChordPoints();

		this.circle.draw({ radians, radius: this.circleRadius });
		this.PointTagManager.updateCoord(radians, this.circleRadius)
		this.AngleManager.draw(chordPoints);
		this.LineManager.draw(redPointsCoord, chordPoints);
	}
}